import {FamiliesCategoriesEdition} from '@/profile-creation-wizard/common/categories/FamiliesCategories';
import {Tag} from '../components/for-creation/Tag';
import {Description, Education} from '../components/for-completion/domain/Profile';
import {Photo} from '@malt/asset-utils';
import {ReasonForJoining, SeniorityLevel} from '../components/for-completion/domain/types';
import {MinMaxRuleResource} from '@/common/api/api-raw-types';
import {ActivityArea, Experience} from '../components/for-completion/domain/experience/Experience';

export type QrCodeSetup = {
    url: string | null;
};

export type ProfileCreationForm = {
    familiesCategoriesEdition: FamiliesCategoriesEdition;
    headline: string | null;
    experienceLevel: ExperienceLevel | null;
    tags: Tag[];
    functionalSkills: FunctionalSkill[];
    industryExpertises: IndustrySkill[];
    price: number;
    priceHide: boolean;
    address: Address;
    workPlacePreference: WorkplacePreference | null;
    languages: Language[];
    phone: string | null;
    invitationCode: string | null;
    groupInvitationId: string | null;
    willingnessToTravelInternationally: boolean;
};

export type ProfileCompletionForm = {
    description: Description;
    educations: Education[] | null;
    photo: Photo | null;
    linkedinResume: File | null;
    seniority: SeniorityLevel | null;
    reasons: ReasonForJoining | null;
    profileDescriptionRule: MinMaxRuleResource;
    experienceDescriptionRule: MinMaxRuleResource;
    educationDescriptionRule: MinMaxRuleResource;
    experiences: Experience[];
    recommendations: RecommendationRequest;
    activityAreas: ActivityArea[];
};

export const defaultAddress: Address = {
    city: null,
    countryCode: null,
    country: null,
    administrativeAreaLevel1: null,
    administrativeAreaLevel1Code: null,
    administrativeAreaLevel2: null,
    administrativeAreaLevel2Code: null,
    administrativeAreaLevel3: null,
    administrativeAreaLevel3Code: null,
    administrativeAreaLevel4: null,
    administrativeAreaLevel4Code: null,
    lon: null,
    lat: null,
    formattedAddress: null,
};

export enum ExperienceLevel {
    ENTRY = 'ENTRY',
    INTERMEDIATE = 'INTERMEDIATE',
    EXPERT = 'EXPERT',
    EXPERT_PLUS = 'EXPERT_PLUS',
}

export type Address = {
    city: string | null;
    countryCode: string | null;
    country: string | null;
    administrativeAreaLevel1: string | null;
    administrativeAreaLevel1Code: string | null;
    administrativeAreaLevel2: string | null;
    administrativeAreaLevel2Code: string | null;
    administrativeAreaLevel3: string | null;
    administrativeAreaLevel3Code: string | null;
    administrativeAreaLevel4: string | null;
    administrativeAreaLevel4Code: string | null;
    lon: number | null;
    lat: number | null;
    formattedAddress: string | null;
    [key: string]: any;
};

export enum WorkplacePreference {
    ONSITE = 'ONSITE',
    REMOTE = 'REMOTE',
}

export type Language = {
    id: number;
    code: string;
    level: LanguageLevel | null;
    query: string | null;
};

export enum LanguageLevel {
    BASIC = 'BASIC',
    CONVERSATIONAL = 'CONVERSATIONAL',
    FLUENT = 'FLUENT',
    NATIVE = 'NATIVE',
}

export type SearchableLanguage = {
    code: string;
    name: string;
};

export type FunctionalScope = {
    label: string;
    functionalSkills: FunctionalSkill[];
};

export type FunctionalSkill = {
    humanId: string;
    label: string;
};

export type IndustrySkill = {
    humanId: string;
    label: string;
};

export type RecommendationRequest = {
    recoTextToSend: string;
    recoEmails: string;
};

export interface StrategyBackground {
    managementConsultant: boolean;
    interimExecutive: boolean;
}

export enum ApplicationStatus {
    SUBMITTED = 'SUBMITTED',
    ACCEPTED = 'ACCEPTED',
    REFUSED = 'REFUSED',
}

export interface PriceConfiguration {
    maxPriceAllowed: number;
    minPriceAllowed: number;
}
